import { Model, Repeat } from "@lernetz/ts-lib";
import { observeProperties } from "@lernetz/ts-lib/src/Observer";
import { View, ViewConfig } from "@lernetz/ts-lib/src/view/View";
import template from "./Carousel.html";

export interface CarouselConfig {
    currentItem:object;
    items?:object[];
}

export class Carousel extends Model {

    public currentItem:object;
    public items: object[];

    public constructor( config?:CarouselConfig ) {
        super( { currentItem: null, items: [], ...config } );

        observeProperties( this, 'currentItem', 'items' );
        this.propertyChange.filter( p => p.name === 'items' ).subscribe( () => {
            this.currentItem = this.items?.length ? this.items[0] : null;
        });
    }

    next() {
        this.currentItem = this.items[ ( this.currentItemIndex + 1 ) % this.items.length ];
    }

    previous() {
        this.currentItem = this.items[ ( this.items.length + this.currentItemIndex - 1 ) % this.items.length ];
    }

    protected get currentItemIndex() {
        return this.items.indexOf( this.currentItem );
    }
}

export class CarouselView extends View<Carousel> {

    public constructor( config?:ViewConfig<Carousel> ) {
        super( { data: new Carousel(), template, ...config } );

        this.registry.add( 'Repeat', () => new Repeat() );
    }
}
